export const GroupNameToInputName: {[key: string]: string} = {
  fertilizer: 'کود',
  pesticide: 'سم',
  seed: 'بذر و نهال',
  employee: 'کار کشاورزی',
  machinery: 'ماشین آلات',
  tool: 'ابزار و تجهیزات',
  farm: 'مزرعه و آب',
  lab: 'آزمایشگاه',
  allNewAds: 'جدیدترین محصولات',
};

export const InputNameToCode: {[key: string]: number} = {
  fertilizer: 11,
  pesticide: 12,
  seed: 13,
  employee: 14,
  machinery: 15,
  tool: 16,
  farm: 17,
  lab: 18,
};

export const InputNameToGroupName: {[key: string]: string} = {
  کود: 'fertilizer',
  سم: 'pesticide',
  'بذر و نهال': 'seed',
  'کار کشاورزی': 'employee',
  'ماشین آلات': 'machinery',
  'ابزار و تجهیزات': 'tool',
  'مزرعه و آب': 'farm',
};

export const labCodeToName: {[key: string]: string} = {
  11: 'آب و خاک',
  13: 'کود و سم',
  14: 'دام و طیور',
};
